import DocsConfig from '@tencent/docs-config';
const appConfigInstance = DocsConfig.getInstance();
const npmConfig = appConfigInstance.getConfig('npm["@tencent/docs-design-resources"]')
let p = (!!npmConfig && npmConfig.CDN_ORIGIN) || 'https://docs.gtimg.com/docs-design-resources';
p = p + '/cooperation/ai/template/template_ppt_techno_mountain_purple/'
export function getTemplateThumbnail1() { return p+'template_thumbnail_1-0323c1c294.png'; };
export function getTemplateThumbnail10() { return p+'template_thumbnail_10-84a3305d18.png'; };
export function getTemplateThumbnail2() { return p+'template_thumbnail_2-4f85748e31.png'; };
export function getTemplateThumbnail3() { return p+'template_thumbnail_3-3bbc670551.png'; };
export function getTemplateThumbnail4() { return p+'template_thumbnail_4-87058145ae.png'; };
export function getTemplateThumbnail5() { return p+'template_thumbnail_5-58e7dd2c24.png'; };
export function getTemplateThumbnail6() { return p+'template_thumbnail_6-361a4fb76d.png'; };
export function getTemplateThumbnail7() { return p+'template_thumbnail_7-499f793749.png'; };
export function getTemplateThumbnail8() { return p+'template_thumbnail_8-d789cfe786.png'; };
export function getTemplateThumbnail9() { return p+'template_thumbnail_9-726dd2774d.png'; };
